import { OpsOrgBrowser } from "@/pages/OpsOrgBrowser";

export default function OpsOrgs() {
  return <OpsOrgBrowser />;
}
